"use client";

import { c as _c } from "react/compiler-runtime";
import { motion } from "framer-motion";
import { useEffect, useRef, useState } from "react";
export default function CommonAnimationHeight(t0) {
  const $ = _c(21);
  const {
    className,
    children,
    onAnimationCompleted,
    onAnimationStart,
    disableAnimation: t1
  } = t0;
  const disableAnimation = t1 === undefined ? false : t1;
  const containerRef = useRef(null);
  const [height, setHeight] = useState("auto");
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      if (!containerRef.current) {
        return;
      }
      const resizeObserver = new ResizeObserver(entries => {
        const observedHeight = entries[0]?.contentRect.height;
        setHeight(observedHeight);
      });
      resizeObserver.observe(containerRef.current);
      return () => {
        resizeObserver.disconnect();
      };
    };
    t3 = [];
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  useEffect(t2, t3);
  const t4 = `${className} tw-overflow-hidden`;
  let t5;
  let t6;
  if ($[2] !== height) {
    t5 = {
      height
    };
    t6 = {
      height
    };
    $[2] = height;
    $[3] = t5;
    $[4] = t6;
  } else {
    t5 = $[3];
    t6 = $[4];
  }
  const t7 = disableAnimation ? 0 : 0.3;
  let t8;
  if ($[5] !== t7) {
    t8 = {
      duration: t7
    };
    $[5] = t7;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  let t9;
  if ($[7] !== onAnimationStart) {
    t9 = onAnimationStart && {
      onAnimationStart
    };
    $[7] = onAnimationStart;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== onAnimationCompleted) {
    t10 = onAnimationCompleted && {
      onAnimationComplete: onAnimationCompleted
    };
    $[9] = onAnimationCompleted;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== children) {
    t11 = <div ref={containerRef}>{children}</div>;
    $[11] = children;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== t10 || $[14] !== t11 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6 || $[18] !== t8 || $[19] !== t9) {
    t12 = <motion.div className={t4} style={t5} animate={t6} transition={t8} {...t9} {...t10}>{t11}</motion.div>;
    $[13] = t10;
    $[14] = t11;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  return t12;
}